// Generated by scripts/system-config-catalogue.mjs from
// docs/telgoo5-reference/system-config-settings.txt. Do not edit by hand; run the script again.
import type { SettingDef } from './settings';

/** Telgoo5's System Config groups, in its order. 212Ez's own "Tax" group comes after them. */
export const SETTING_GROUP_ORDER: readonly string[] = [
  'Enrollment',
  'Agent Compliance',
  'General',
  'Inventory',
  'Shipment',
  'Review',
  'Suretax Setting',
  'ILD PROCESSING FEE',
  'POS Setting',
  'User Setting',
  'Plan Change/Renew Config',
  'NETIP Config',
  'Generate Commission',
  'Usages Settings According To Carrier For Activation',
  'PIN Management',
  'Customer Portal Setting',
  'Family Plan Config',
  'Autopay and Payment',
  'Notification Config',
  'Billing Config',
  'Fraud Prevention',
  'REST API Config',
  'CSR Config',
  'Report Config',
  'Outage',
  'Manage System Config',
  'Port-out Config Blueconnectsatt',
  'Tax',
];

/** Where each reference setting stands on the Telgoo5 page, by its SC code. */
export const SETTING_CODE_ORDER: Readonly<Record<string, number>> = {
  SC01: 0,
  SC32: 1,
  SC31: 2,
  SC02: 3,
  SC430: 4,
  SC03: 5,
  SC04: 6,
  SC05: 7,
  SC06: 8,
  SC07: 9,
  SC08: 10,
  SC09: 11,
  SC10: 12,
  SC11: 13,
  SC12: 14,
  SC13: 15,
  SC14: 16,
  SC16: 17,
  SC17: 18,
  SC18: 19,
  SC19: 20,
  SC20: 21,
  SC22: 22,
  SC23: 23,
  SC24: 24,
  SC25: 25,
  SC26: 26,
  SC27: 27,
  SC28: 28,
  SC29: 29,
  SC30: 30,
  SC33: 31,
  SC35: 32,
  SC36: 33,
  SC37: 34,
  SC38: 35,
  SC39: 36,
  SC40: 37,
  SC41: 38,
  SC42: 39,
  SC43: 40,
  SC44: 41,
  SC45: 42,
  SC46: 43,
  SC47: 44,
  SC48: 45,
  SC49: 46,
  SC50: 47,
  SC51: 48,
  SC52: 49,
  SC53: 50,
  SC54: 51,
  SC55: 52,
  SC683: 53,
  SC56: 54,
  SC57: 55,
  SC58: 56,
  SC59: 57,
  SC60: 58,
  SC61: 59,
  SC62: 60,
  SC63: 61,
  SC64: 62,
  SC65: 63,
  SC66: 64,
  SC67: 65,
  SC684: 66,
  SC685: 67,
  SC72: 68,
  SC73: 69,
  SC723: 70,
  SC678: 71,
  SC679: 72,
  SC1437: 73,
  SC1504: 74,
  SC76: 75,
  SC77: 76,
  SC78: 77,
  SC79: 78,
  SC80: 79,
  SC81: 80,
  SC82: 81,
  SC83: 82,
  SC84: 83,
  SC85: 84,
  SC86: 85,
  SC87: 86,
  SC88: 87,
  SC89: 88,
  SC90: 89,
  SC91: 90,
  SC92: 91,
  SC93: 92,
  SC94: 93,
  SC95: 94,
  SC96: 95,
  SC97: 96,
  SC98: 97,
  SC101: 98,
  SC102: 99,
  SC103: 100,
  SC104: 101,
  SC105: 102,
  SC106: 103,
  SC107: 104,
  SC108: 105,
  SC109: 106,
  SC110: 107,
  SC489: 108,
  SC111: 109,
  SC112: 110,
  SC113: 111,
  SC114: 112,
  SC496: 113,
  SC1320: 114,
  SC479: 115,
  SC480: 116,
  SC121: 117,
  SC129: 118,
  SC164: 119,
  SC1237: 120,
  SC686: 121,
  SC130: 122,
  SC132: 123,
  SC133: 124,
  SC134: 125,
  SC135: 126,
  SC136: 127,
  SC137: 128,
  SC138: 129,
  SC139: 130,
  SC140: 131,
  SC141: 132,
  SC142: 133,
  SC143: 134,
  SC144: 135,
  SC145: 136,
  SC146: 137,
  SC147: 138,
  SC148: 139,
  SC149: 140,
  SC150: 141,
  SC151: 142,
  SC152: 143,
  SC153: 144,
  SC154: 145,
  SC155: 146,
  SC687: 147,
  SC1233: 148,
  SC460: 149,
  SC157: 150,
  SC163: 151,
  SC902: 152,
  SC158: 153,
  SC561: 154,
  SC1472: 155,
  SC875: 156,
  SC565: 157,
  SC156: 158,
  SC122: 159,
  SC804: 160,
  SC909: 161,
  SC1486: 162,
  SC1496: 163,
  SC1145: 164,
  SC1445: 165,
  SC1473: 166,
  SC478: 167,
  SC123: 168,
  SC1541: 169,
  SC1539: 170,
  SC688: 171,
  SC689: 172,
  SC166: 173,
  SC125: 174,
  SC690: 175,
  SC691: 176,
  SC173: 177,
  SC174: 178,
  SC175: 179,
  SC176: 180,
  SC177: 181,
  SC178: 182,
  SC179: 183,
  SC180: 184,
  SC181: 185,
  SC182: 186,
  SC183: 187,
  SC184: 188,
  SC185: 189,
  SC186: 190,
  SC187: 191,
  SC188: 192,
  SC189: 193,
  SC190: 194,
  SC191: 195,
  SC581: 196,
  SC212: 197,
  SC840: 198,
  SC204: 199,
  SC205: 200,
  SC841: 201,
  SC217: 202,
  SC218: 203,
  SC219: 204,
  SC220: 205,
  SC221: 206,
  SC222: 207,
  SC223: 208,
  SC224: 209,
  SC225: 210,
  SC226: 211,
  SC227: 212,
  SC228: 213,
  SC229: 214,
  SC230: 215,
  SC1362: 216,
  SC99: 217,
  SC1490: 218,
  SC1508: 219,
  SC515: 220,
  SC251: 221,
  SC252: 222,
  SC253: 223,
  SC254: 224,
  SC255: 225,
  SC256: 226,
  SC257: 227,
  SC258: 228,
  SC259: 229,
  SC260: 230,
  SC261: 231,
  SC262: 232,
  SC263: 233,
  SC264: 234,
  SC265: 235,
  SC266: 236,
  SC267: 237,
  SC268: 238,
  SC269: 239,
  SC270: 240,
  SC271: 241,
  SC272: 242,
  SC692: 243,
  SC273: 244,
  SC274: 245,
  SC275: 246,
  SC276: 247,
  SC277: 248,
  SC282: 249,
  SC283: 250,
  SC285: 251,
  SC287: 252,
  SC281: 253,
  SC1027: 254,
  SC1012: 255,
  SC286: 256,
  SC1278: 257,
  SC585: 258,
  SC1046: 259,
  SC1044: 260,
  SC590: 261,
  SC475: 262,
  SC301: 263,
  SC302: 264,
  SC304: 265,
  SC305: 266,
  SC306: 267,
  SC307: 268,
  SC308: 269,
  SC592: 270,
  SC593: 271,
  SC594: 272,
  SC595: 273,
  SC596: 274,
  SC597: 275,
  SC903: 276,
  SC1332: 277,
  SC1511: 278,
  SC310: 279,
  SC311: 280,
  SC312: 281,
  SC313: 282,
  SC314: 283,
  SC315: 284,
  SC316: 285,
  SC317: 286,
  SC318: 287,
  SC319: 288,
  SC320: 289,
  SC321: 290,
  SC322: 291,
  SC323: 292,
  SC324: 293,
  SC325: 294,
  SC326: 295,
  SC327: 296,
  SC328: 297,
  SC330: 298,
  SC693: 299,
  SC331: 300,
  SC332: 301,
  SC333: 302,
  SC343: 303,
  SC334: 304,
  SC335: 305,
  SC347: 306,
  SC1679: 307,
  SC348: 308,
  SC694: 309,
  SC725: 310,
  SC843: 311,
  SC844: 312,
  SC350: 313,
  SC1648: 314,
  SC1512: 315,
  SC352: 316,
  SC353: 317,
  SC354: 318,
  SC357: 319,
  SC358: 320,
  SC695: 321,
  SC360: 322,
  SC696: 323,
  SC362: 324,
  SC697: 325,
  SC364: 326,
  SC365: 327,
  SC366: 328,
  SC367: 329,
  SC368: 330,
  SC369: 331,
  SC370: 332,
  SC371: 333,
  SC372: 334,
  SC373: 335,
  SC698: 336,
  SC699: 337,
  SC377: 338,
  SC378: 339,
  SC700: 340,
  SC383: 341,
  SC726: 342,
  SC379: 343,
  SC376: 344,
  SC375: 345,
  SC381: 346,
  SC384: 347,
  SC385: 348,
  SC386: 349,
  SC387: 350,
  SC388: 351,
  SC701: 352,
  SC702: 353,
  SC389: 354,
  SC727: 355,
  SC397: 356,
  SC846: 357,
  SC399: 358,
  SC1411: 359,
  SC1243: 360,
  SC401: 361,
  SC402: 362,
  SC703: 363,
  SC847: 364,
  SC670: 365,
  SC714: 366,
  SC715: 367,
  SC716: 368,
  SC717: 369,
  SC718: 370,
  SC719: 371,
  SC720: 372,
  SC721: 373,
  SC722: 374,
  SC416: 375,
  SC1418: 376,
  SC1419: 377,
  SC1421: 378,
};

/**
 * The reference settings 212Ez does not act on yet. They are kept and shown, marked as not used, so
 * System Config holds every setting of the reference; a feature that starts reading one moves it into
 * SETTING_DEFS (shared/src/settings.ts) and runs this script again.
 */
export const CATALOGUE_SETTING_DEFS = [
  {
    key: 'PREPAID_MULTIPLE_ENROLLMENT',
    code: 'SC01',
    category: 'Enrollment',
    label: 'Prepaid Multiple Enrollment',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'NONLIFELINE_WEBSITE_PREFIX',
    code: 'SC32',
    category: 'Enrollment',
    label: 'Non-Lifeline Website Prefix',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'MAX_LINE_PREPAID_ENROLL',
    code: 'SC02',
    category: 'Enrollment',
    label: 'MAX Line Prepaid Multiple Enrollment',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'SPECIAL_CHARACTERS_ALLOW',
    code: 'SC430',
    category: 'Enrollment',
    label: 'Special Characters Allow',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'PREPAID_MULTIPLE_COMPANY_ENROLLMENT',
    code: 'SC03',
    category: 'Enrollment',
    label: 'Prepaid Multiple Company Enrollment',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'LL_MULTIPLE_COMPANY_ENROLLMENT',
    code: 'SC04',
    category: 'Enrollment',
    label: 'LifeLine Multiple Company Enrollment',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'EMPLOYEE_PLAN_SETTING',
    code: 'SC05',
    category: 'Enrollment',
    label: 'Allow Agent LifeLine Enrollment Selected Plan',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'EMPLOYEE_PLAN_SETTING_PREAPAID',
    code: 'SC06',
    category: 'Enrollment',
    label: 'Allow Agent Prepaid Enrollment Selected Plan',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'LL_ENROLLMENT_DISBALED',
    code: 'SC07',
    category: 'Enrollment',
    label: 'LifeLine Enrollment Disabled state',
    type: 'states',
    default: [],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'TS_ENROLLMENT_DISBALED',
    code: 'SC08',
    category: 'Enrollment',
    label: 'Telesales Enrollment Disabled state',
    type: 'states',
    default: [],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'HOUSEHOLD_DEFAULT_OPEN',
    code: 'SC11',
    category: 'Enrollment',
    label: 'Household Form Default Open',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'NLAD_CHECKING_HOUSEHOLD_STEP2',
    code: 'SC12',
    category: 'Enrollment',
    label: 'Nlad Checking Household Step2',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'STEP2_BENEFICIARY_DETAIL',
    code: 'SC13',
    category: 'Enrollment',
    label: 'Show Step2 Beneficiary Detail',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'STEP3_BENEFICIARY_DETAIL',
    code: 'SC14',
    category: 'Enrollment',
    label: 'Show Step3 Beneficiary Detail',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'STEP3_REVIEW_QUESTION',
    code: 'SC16',
    category: 'Enrollment',
    label: 'Step3 Review Question',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'GETSUFFIXDATA',
    code: 'SC17',
    category: 'Enrollment',
    label: 'Get Suffix Data with Name',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'PORTFREEZE_BENEFIT_TRANSFER',
    code: 'SC18',
    category: 'Enrollment',
    label: 'PortFreez Benefit Transfer',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'SHOW_UPGRADE_PLAN',
    code: 'SC19',
    category: 'Enrollment',
    label: 'Show Upgrade Plan',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ELECTRONICALLY_SIGNED',
    code: 'SC20',
    category: 'Enrollment',
    label: 'Electronically Signed',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'DIRECT_NLAD_ENROLL',
    code: 'SC22',
    category: 'Enrollment',
    label: 'Direct Nlad Enroll',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'STEP3_TPIV_FAIL_PROCEED',
    code: 'SC23',
    category: 'Enrollment',
    label: 'STEP3 TPIV FAIL PROCEED',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'CONSENT_ENROLL',
    code: 'SC24',
    category: 'Enrollment',
    label: 'Consent Enroll',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'CCPAYMENT',
    code: 'SC25',
    category: 'Enrollment',
    label: 'Credit Card Payment',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'LL_SKIPPAYMENT',
    code: 'SC28',
    category: 'Enrollment',
    label: 'LifeLine Skip Payment',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'WALLET_PAYMENT',
    code: 'SC29',
    category: 'Enrollment',
    label: 'Wallet Payment',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'PAYLATER_PAYMENT',
    code: 'SC30',
    category: 'Enrollment',
    label: 'PayLater Payment',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'SHOW_STEP2_PHONETYPE_PREPAID',
    code: 'SC35',
    category: 'Enrollment',
    label: 'Show Step2 Phonetype Prepaid',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'SHOW_STEP2_PORTINGBOX_PREPAID',
    code: 'SC36',
    category: 'Enrollment',
    label: 'Show Step2 Porting Box Prepaid',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'SHOW_STEP2_PORTINGBOX_PREPAID_IOT',
    code: 'SC37',
    category: 'Enrollment',
    label: 'Show Step2 Portingbox Prepaid IOT',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'AUTOPAY_SETTING',
    code: 'SC38',
    category: 'Enrollment',
    label: 'Autopay Setting',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'PEEARLESSMDN',
    code: 'SC39',
    category: 'Enrollment',
    label: 'PEEARLESSMDN',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'TPIV_FAIL_ATTEMPT',
    code: 'SC40',
    category: 'Enrollment',
    label: 'Tpiv Fail Attempt',
    type: 'select',
    default: '1',
    options: ['1', '2', '3', '4'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'MOVE_AHEAD_TPIV_FAIL',
    code: 'SC41',
    category: 'Enrollment',
    label: 'Move Ahead After Tpiv Fail',
    type: 'select',
    default: '2',
    options: ['2', '3', '4'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ACTIVATION_FEE',
    code: 'SC42',
    category: 'Enrollment',
    label: 'ACTIVATION FEE',
    type: 'select',
    default: 'PLAN',
    options: ['PLAN', 'ESN'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'SHELTER_ADDRESS',
    code: 'SC43',
    category: 'Enrollment',
    label: 'Shelter Address Service',
    type: 'select',
    default: 'ON',
    options: ['ON', 'OFF'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'QUICKTEL_DUPLICATE_SERVICE_ADDRESS',
    code: 'SC44',
    category: 'Enrollment',
    label: 'Service Address Duplicate Check (Third party DB)',
    type: 'select',
    default: 'ON',
    options: ['ON', 'OFF'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'NEVADA_STATE_API',
    code: 'SC46',
    category: 'Enrollment',
    label: 'Nevada State API',
    type: 'select',
    default: 'ON',
    options: ['ON', 'OFF'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'AUTOPAY_CONTENT_MESSAGE',
    code: 'SC47',
    category: 'Enrollment',
    label: 'Autopay Content Message',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'HANDOVER_CONFIG',
    code: 'SC48',
    category: 'Enrollment',
    label: 'Handover Config',
    type: 'select',
    default: 'OLD HANDOVER PROCESS',
    options: ['OLD HANDOVER PROCESS', 'NEW HANDOVER PROCESS', 'NEW VERSION HANDOVER PROCESS'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'SHOW_STEP2_INT_MAIL_ADDRESS',
    code: 'SC49',
    category: 'Enrollment',
    label: 'Show Step2 International Mailing Address',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'USAC_IMPLEMENT',
    code: 'SC50',
    category: 'Enrollment',
    label: 'USAC Implement',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'PREVIEW_DOWNLOAD_FORM',
    code: 'SC51',
    category: 'Enrollment',
    label: 'Preview Download Form',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'DISPLAY_HELP_INFORMATION',
    code: 'SC52',
    category: 'Enrollment',
    label: 'Display Help Information',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'MANAGE_USER_LEVEL_ACCESS_ON_HANDOVER',
    code: 'SC53',
    category: 'Enrollment',
    label: 'Manage User Level Access On Handover',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'PIN_PAYMENT',
    code: 'SC54',
    category: 'Enrollment',
    label: 'PIN Payment',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'IOT_FP_HANDOVER_CONFIG',
    code: 'SC55',
    category: 'Enrollment',
    label: 'Handover Config (Multi Line Prepaid, Family Plan and IOT)',
    type: 'select',
    default: 'OLD HANDOVER PROCESS',
    options: ['OLD HANDOVER PROCESS', 'NEW HANDOVER PROCESS'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'NEW_IOT_FP_HANDOVER_CONFIG',
    code: 'SC683',
    category: 'Enrollment',
    label: 'New Handover Config (Multi Line Prepaid, Family Plan and IOT)',
    type: 'select',
    default: 'OLD HANDOVER PROCESS',
    options: ['OLD HANDOVER PROCESS', 'NEW HANDOVER PROCESS'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ALLOW_UICCID_IN_ESN_ONLY_FOR_TELGOOATT',
    code: 'SC56',
    category: 'Enrollment',
    label: 'Allow handover from uiccid in esn input(Only For TELGOOATT)',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'IOT_ORDER_DISPLAY_NAME',
    code: 'SC57',
    category: 'Enrollment',
    label: 'IOT Orders Display Name',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'PREPAID_CUSTOMER_ADDITION_FIELD_COMPANY_TAX_ID_DISPLAY',
    code: 'SC58',
    category: 'Enrollment',
    label: 'Prepaid Postpaid Customer Additional Fields Display(Company Name and Tax ID)',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'PREPAID_CUSTOMER_ADDITION_FIELD_DISPLAY',
    code: 'SC59',
    category: 'Enrollment',
    label: 'Prepaid Postpaid Customer Additional Fields Display(SSN and DOB)',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ALLOW_MAILING_ADDRESS_TO_PAYMENT_BILLING_ADDRESS',
    code: 'SC60',
    category: 'Enrollment',
    label: 'Allow only mailing address in payment billing address',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'HANDOVER_AUTOPAY_ENABLED_ONLY',
    code: 'SC61',
    category: 'Enrollment',
    label: 'Default auto pay enabled only (In Handover Credit Card Payment)',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ALLOW_PHONE_MODEL_SELECTION',
    code: 'SC62',
    category: 'Enrollment',
    label: 'Allow Phone Model Selection For Shipment In Handover Screen',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ALLOW_BULK_PORTIN_FROM_BULK_ENROLLMENT',
    code: 'SC63',
    category: 'Enrollment',
    label: 'Allow Bulk Portin From Bulk Enrollment',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ENABLE_PERCENTAGE_WISE_TAX_CONFIG',
    code: 'SC64',
    category: 'Enrollment',
    label: 'Enable Voice/Text/Data Percentage Wise tax config',
    type: 'select',
    default: 'Y',
    options: ['Y', 'PLUM_EVAD_STRIPE', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'PLAN_CONFIG_ALLOW_BUCKET_UPDATE',
    code: 'SC65',
    category: 'Enrollment',
    label: 'Allow to update plan bucket( Only Display bucket)',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'PLAN_CONFIG_ALLOW_CHARGE_APPLICABLE',
    code: 'SC66',
    category: 'Enrollment',
    label: 'Allow Manage Charges In Plan Config',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'FRAUD_PREVENTION_PREPAID_POSTPAID',
    code: 'SC67',
    category: 'Enrollment',
    label: 'Fraud Prevention Prepaid Postpaid',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'PORTIN_PAYMENT_PAGE_CONFIG',
    code: 'SC684',
    category: 'Enrollment',
    label: 'New Portin Payment Page Config',
    type: 'select',
    default: 'OLD PAYMENT PROCESS',
    options: ['OLD PAYMENT PROCESS', 'NEW PAYMENT PROCESS'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ALLOW_FAILED_PORTIN_TO_REPROCESS',
    code: 'SC685',
    category: 'Enrollment',
    label: 'Allow Failed Port-in to reprocess',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ADD_PRODUCT_ASYNC_BASED_PLUM',
    code: 'SC723',
    category: 'Enrollment',
    label: 'Allow Add Product Async Based Plum',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ALLOW_BUSINESS_ADDRESS_MAILING_ADDRESS',
    code: 'SC678',
    category: 'Enrollment',
    label: 'Allow business address of Mailing address',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ALLOW_BUSINESS_ADDRESS_SERVICE_ADDRESS',
    code: 'SC679',
    category: 'Enrollment',
    label: 'Allow business address of Service address',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ALLOW_CUSTOMER_PASSWORD_ENCRYPTED',
    code: 'SC1437',
    category: 'Enrollment',
    label: 'Allow customer password encrypted(For Prepaid Only)',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'TELGOO_ENCRYPT_WITH_SALT',
    code: 'SC1504',
    category: 'Enrollment',
    label: 'Customer password encryption with salt',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'SUSPEND_ACTIVE_AGENT_ENROLLMENT',
    code: 'SC76',
    category: 'Agent Compliance',
    label: 'Suspend Active Agent Enrollment',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'TIME_TO_SUSPEND_ACTIVE_AGENT',
    code: 'SC77',
    category: 'Agent Compliance',
    label: 'Time To Suspend Active Agent',
    type: 'select',
    default: '07:00:00',
    options: [
      '07:00:00',
      '08:00:00',
      '09:00:00',
      '10:00:00',
      '11:00:00',
      '12:00:00',
      '13:00:00',
      '14:00:00',
      '15:00:00',
      '16:00:00',
      '17:00:00',
      '18:00:00',
      '19:00:00',
      '20:00:00',
      '21:00:00',
      '22:00:00',
      '23:00:00',
    ],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ENROLLMENT_RADIUS_DISTANCE',
    code: 'SC78',
    category: 'Agent Compliance',
    label: 'Enrollment Radius Distance',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ALLOW_STOP_OFF_HOURS_ENROLLMENT',
    code: 'SC79',
    category: 'Agent Compliance',
    label: 'Allow Stop Off Hours Enrollment',
    type: 'boolean',
    default: false,
    options: ['YES', 'NO'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ENROLLMENT_START_TIME',
    code: 'SC80',
    category: 'Agent Compliance',
    label: 'Enrollment Start Time',
    type: 'select',
    default: '08:00:00',
    options: [
      '08:00:00',
      '08:30:00',
      '09:00:00',
      '09:30:00',
      '10:00:00',
      '10:30:00',
      '11:00:00',
      '11:30:00',
      '12:00:00',
    ],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ENROLLMENT_END_TIME',
    code: 'SC81',
    category: 'Agent Compliance',
    label: 'Enrollment End Time',
    type: 'select',
    default: '13:00:00',
    options: [
      '13:00:00',
      '13:30:00',
      '14:00:00',
      '14:30:00',
      '15:00:00',
      '15:30:00',
      '16:00:00',
      '16:30:00',
      '17:00:00',
      '17:30:00',
      '18:00:00',
      '18:30:00',
      '19:00:00',
      '19:30:00',
      '20:00:00',
      '20:30:00',
      '21:00:00',
      '21:30:00',
      '22:00:00',
      '22:30:00',
    ],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'VER_HOTLINE_NO',
    code: 'SC86',
    category: 'General',
    label: 'Hotline Number',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'PERMISSION_MESSAGE',
    code: 'SC88',
    category: 'General',
    label: 'Permission Message',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'CONFIG_TOPUP_PAYMENT_TYPE',
    code: 'SC89',
    category: 'General',
    label: 'Config Topup Payment Type (Comma Separated)',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'CONFIG_TOPUP_PLAN_TYPE',
    code: 'SC90',
    category: 'General',
    label: 'Config Topup Plan Type (Comma Separated)',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'STARZ_CONFIG',
    code: 'SC91',
    category: 'General',
    label: 'Starz Service',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'VCARE_CALL_CENTER_LIST',
    code: 'SC95',
    category: 'General',
    label: 'Vcare Call Center List',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ARR_STATE_NLAD_GLOBAL',
    code: 'SC96',
    category: 'General',
    label: 'Array State Nlad Global',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'DATE_FORMAT_CONSTANT',
    code: 'SC97',
    category: 'General',
    label: 'Tooltip Date Display Format',
    type: 'select',
    default: 'DD MM YYYY(01 Jan 2001)',
    options: ['DD MM YYYY(01 Jan 2001)', 'MM DD YYYY(Jan 01 2001)', 'YYYY DD MM(2001 01 Jan)'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'DISPLAY_DATE_FORMAT_CONSTANT',
    code: 'SC98',
    category: 'General',
    label: 'Date Display Format',
    type: 'select',
    default: 'DD MM YYYY(01 Jan 2001)',
    options: [
      'DD MM YYYY(01 Jan 2001)',
      'MM DD YYYY(Jan 01 2001)',
      'mm DD YYYY(01 25 2001)',
      'YYYY DD MM(2001 01 Jan)',
    ],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'NV_ARR_STATE_NLAD_GLOBAL',
    code: 'SC101',
    category: 'General',
    label: 'NV Array State Nlad Global',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'NV_ARR_STATE_REVIEW_BYPASS',
    code: 'SC102',
    category: 'General',
    label: 'NV Array State Review Bypass',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'DISPLAY_PLAN_CONFIG',
    code: 'SC104',
    category: 'General',
    label: 'Display Plan Config',
    type: 'select',
    default: 'New',
    options: ['New', 'New_Version'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'PLAN_CONFIG_TOOLTIP',
    code: 'SC105',
    category: 'General',
    label: 'Plan Config Tooltip',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'PLAN_CONFIG_DATA_ROAMING_ZONE',
    code: 'SC106',
    category: 'General',
    label: 'Plan Config Data Roaming Zone',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'VCAREOSSAPI_PASSWORD_EXPIRY_DAYS',
    code: 'SC107',
    category: 'General',
    label: 'VcareOSSApi Old Password Expiry Days',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'VCAREOSSAPI_PASSWORD_EXPIRY_EMAIL',
    code: 'SC108',
    category: 'General',
    label: 'VcareOSSApi Password Expiry Notification Email ID',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ENROLLMENT_CREDIT_AMOUNT_TO_ADD_IN_WALLET_NON_FAMILY_PLAN',
    code: 'SC109',
    category: 'General',
    label: 'Enrollment Credit Amount To Add In Wallet(Non Family Plan Only)',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ENROLLMENT_CREDIT_AMOUNT_TO_ADD_IN_WALLET_FAMILY_PLAN',
    code: 'SC110',
    category: 'General',
    label: 'Enrollment Credit Amount To Add In Wallet(Family Plan Only)',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'SHOW_HIDE_INVOICE_DOWNLOAD_EMAIL_OPTION',
    code: 'SC489',
    category: 'General',
    label: 'Show/Hide Invoice Download and Send Email Option Invoice Tab',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'SHOW_HIDE_INVOICE_DOWNLOAD_EMAIL_OPTION_CUSTOM',
    code: 'SC111',
    category: 'General',
    label: 'Show/Hide Invoice Download and Send Email Option Invoice Tab(Custom)',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'INVOICE_PDF_GENERATE_TYPE',
    code: 'SC112',
    category: 'General',
    label: 'Invoice PDF Generate Type',
    type: 'select',
    default: 'IMMEDIATE',
    options: ['IMMEDIATE', 'LATER_FROM_BACKEND_PROCESS'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'INVOICE_DOWNLOAD_SENDEMAIL_OPTION',
    code: 'SC113',
    category: 'General',
    label: 'Invoice Download and send email option',
    type: 'select',
    default: 'DEFAULT',
    options: ['DEFAULT', 'WITH_POPUP'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ALLOW_MANUAL_REFUND',
    code: 'SC114',
    category: 'General',
    label: 'Allow Manual Refund',
    type: 'boolean',
    default: false,
    options: ['YES', 'NO'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ALLOW_GOOGLE_AUTHENTICATOR_BASE_LOGIN',
    code: 'SC496',
    category: 'General',
    label: 'Allow login google authenticator based login',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'PREPAID_INVOICE_NEW_PDF_FORMAT',
    code: 'SC1320',
    category: 'General',
    label: 'Prepaid Invoice New PDF Format',
    type: 'boolean',
    default: false,
    options: ['Yes', 'No'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'AGENT_URL',
    code: 'SC479',
    category: 'General',
    label: 'Agent URL',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ALLOW_DECRYPTED_AGENT_AFFILIATE_URL',
    code: 'SC480',
    category: 'General',
    label: 'Allow Decrypted Agent Affiliate URL',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'PY_WORKERS',
    code: 'SC121',
    category: 'Inventory',
    label: 'Number of Workers?',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'FAMILY_PLAN_CHECK_DROPSHIP',
    code: 'SC129',
    category: 'Inventory',
    label: 'Allow Family Plan Check On Dropshipment',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ASSIGN_BYOD_DEVICE_ON_SHIPMENT',
    code: 'SC164',
    category: 'Inventory',
    label: 'Add BYOD Device ON Dropshiment',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ASSIGN_BYOD_DEVICE_MODEL_ON_SHIPMENT',
    code: 'SC1237',
    category: 'Inventory',
    label: 'Add BYOD Device Model(BYOD GSM, BYOD CDMA) basis on carrier, ON Dropshiment',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ALLOW_NON_ELECTRONIC_SIM_SWAP_WITHOUT_ADD_IN_WHOLESALE',
    code: 'SC686',
    category: 'Inventory',
    label: 'Allow Non Electronic Sim Swap Without Add In Wholesale',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'CUSTOMER_ACTIVATION_AFTER_DROPSHIP',
    code: 'SC130',
    category: 'Inventory',
    label: 'Customer Activation After Dropship Without Print Label',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'CARRIER_LIST_TO_ACTIVATE_LL_CUSTOMER',
    code: 'SC132',
    category: 'Inventory',
    label: 'Carrier List To call activation at the time dropshipment( Comma separated)',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'DROPSHIP_MULTIPLE_ESN_POPUP',
    code: 'SC133',
    category: 'Inventory',
    label: 'Dropship add multiple ESN in popup',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'SHIPMENT_COMPANY_HELP_NUMBER',
    code: 'SC134',
    category: 'Inventory',
    label: 'Shipment Print Label Company Help Number',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'SHIPMENT_MULTIPLE_ESN_SCAN_PROCESS',
    code: 'SC135',
    category: 'Inventory',
    label: 'Shipment Multiple ESN/SIM Scan',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'MULTIPLE_BATCH',
    code: 'SC136',
    category: 'Inventory',
    label: 'Add Multiple Batch For Add Unit',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'UPDATE_ASSIGN_PLAN_TYPE',
    code: 'SC137',
    category: 'Inventory',
    label: 'Add Update/Assign Plan Type For Plan Filtering',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ADD_FORM_POPUP',
    code: 'SC138',
    category: 'Inventory',
    label: 'Add Form Popup',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'EQUIPMENT_PURCHASE',
    code: 'SC139',
    category: 'Inventory',
    label: 'Add Equipment Purchase For Battery And Charger',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'USER_ACCESS_LEVEL_ON_AGENT',
    code: 'SC141',
    category: 'Inventory',
    label: 'User Access Level On Agent.',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'WEBSITE_COLUMN_IN_MODEL',
    code: 'SC142',
    category: 'Inventory',
    label: 'Show Website Fields in Model?',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ADD_CHILD_MODEL',
    code: 'SC143',
    category: 'Inventory',
    label: 'Add Child Model',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'CHILD_RAM_DENOMINATIONS',
    code: 'SC144',
    category: 'Inventory',
    label: 'Model RAM denominations',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'CHILD_INTERNAL_DENOMINATIONS',
    code: 'SC145',
    category: 'Inventory',
    label: 'Model Internal Memory denominations',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'CHILD_COLOR_LIST',
    code: 'SC146',
    category: 'Inventory',
    label: 'Model Color List',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'UPDATE_UICCID',
    code: 'SC147',
    category: 'Inventory',
    label: 'Update UICCID in Update Inventory',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'CHANGE_LABEL',
    code: 'SC148',
    category: 'Inventory',
    label: 'Change Label on Basis of ZATT',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ALLOW_DEVICEID2_ADDUNIT',
    code: 'SC149',
    category: 'Inventory',
    label: 'Allow Device ID2 in ADD Unit??',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'NEW_INVENTORY_PROCESS',
    code: 'SC150',
    category: 'Inventory',
    label: 'Allow to change New Inventory Process??',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'DROPSHIP_PREPAID_POSTPAID_PLAN_NEW',
    code: 'SC151',
    category: 'Inventory',
    label: 'Dropship prepaid,postpaid queue acoording to plan',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'NOT_PROVISION_DROPSHIPMENT',
    code: 'SC152',
    category: 'Inventory',
    label: 'Not Provision Dropshipment',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'NON_ADDITIONAL_FIELDS',
    code: 'SC153',
    category: 'Inventory',
    label: 'Allow Non Additional Fields On Add Unit??',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'SHOW_PORTIN_FLAG_MODEL_POPUP',
    code: 'SC154',
    category: 'Inventory',
    label: 'Show Portin Flag in Model Popup Dropship',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'SHIPPING_CHARGE_TRANSCODE',
    code: 'SC155',
    category: 'Inventory',
    label: 'Add Shipping Charge Transcode on Manage Equipment??',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'WEBSITE_PREPAID_URL',
    code: 'SC1233',
    category: 'Inventory',
    label: 'Prepaid Website URL for Tag Manager',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'EBB_DEVICE_CALCULATE_COPAY_COST',
    code: 'SC460',
    category: 'Inventory',
    label: 'EBB Device Calculate Copay Cost',
    type: 'boolean',
    default: false,
    options: ['YES', 'NO'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'MODEL_MANUFACT_TYPE',
    code: 'SC157',
    category: 'Inventory',
    label: 'Model Manufacturer',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'MODEL_IMAGE_UPLOAD_IN_DIRECTORY',
    code: 'SC163',
    category: 'Inventory',
    label: 'Model Image Upload In Directory',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'MODEL_DEVICE_TYPE',
    code: 'SC902',
    category: 'Inventory',
    label: 'Model Device Type',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'UPDATE_MODEL_ON_OTHER',
    code: 'SC158',
    category: 'Inventory',
    label: 'Update Model on Other Client?',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'SHOW_ACP_DEVICE_COPAY_COST',
    code: 'SC561',
    category: 'Inventory',
    label: 'Show ACP Device CO-PAY Cost on Add Unit?',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ATTACH_DEVICE_ID_MAKE_MODEL_ID',
    code: 'SC1472',
    category: 'Inventory',
    label: 'Attach Device Id with Make Model Id',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'EQUIPMENT_PURCHASE_WITH_MULTIPLE_CHILD',
    code: 'SC875',
    category: 'Inventory',
    label: 'Equpment purchase with multiple child',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'SHIPSTATION_ALLOW_TO_GENERATE_PRINT_LABEL',
    code: 'SC565',
    category: 'Inventory',
    label: 'Shipstation allow to generate print label',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'MEID_TAGGED_WITH_ESN',
    code: 'SC156',
    category: 'Inventory',
    label: 'MEID/Device ID Tagging with ESN/SIM',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ADD_SHIPPER_NONE_IN_DROPSHIPMENT',
    code: 'SC122',
    category: 'Inventory',
    label: 'Add shipper none in Dropshipment',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'NAME_ADDRESS_NONE_SHIPPER_PRINT_LABEL',
    code: 'SC804',
    category: 'Inventory',
    label: 'Show Name and Shipping Address For NONE Shipper print label in shipment',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'REFERRAL_URL_THROUGH_QR_CODE',
    code: 'SC909',
    category: 'Inventory',
    label: 'Refferel URL through QR Code',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'REFERRAL_URL_THROUGH_QR_CODE_NL',
    code: 'SC1486',
    category: 'Inventory',
    label: 'Refferel URL through QR Code NL',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'SHIPMENT_ACTIVE_ORDER_SHOW',
    code: 'SC1496',
    category: 'Inventory',
    label: 'Shipment Active Order Show',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'SHIPPING_QUEUE_REPORT_PERMISSION_BASED',
    code: 'SC1145',
    category: 'Inventory',
    label: 'Shipping queue report permission based',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'SHOW_PLAN_AND_ZIP_IN_NOT_PROVISION',
    code: 'SC1445',
    category: 'Inventory',
    label: 'Show Plan and Zipcode in Not Provision',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ADD_AND_ASSIGN_NON_ACTIVATED_PLAN_CODE_BASED',
    code: 'SC1473',
    category: 'Inventory',
    label: 'Add and assign non activated plan code based',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ALLOW_GENERATE_AGENT_URL',
    code: 'SC478',
    category: 'Inventory',
    label: 'Allow Generate Agent URL',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'UPDATE_ESN_DEVICE_CHAIN_ON_DROPSHIMENT',
    code: 'SC123',
    category: 'Inventory',
    label: 'Update ESN Device chain on dropshipment',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'RESTRICT_AGENT_OWN_DATA',
    code: 'SC1541',
    category: 'Inventory',
    label: 'Restrict Agent View to Display Only Their Own Data',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'SEND_QR_CODE_ON_ACTIVATION_ESIM',
    code: 'SC1539',
    category: 'Inventory',
    label: 'Send QR Code on activation eSIM',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'SOLIX_ENROLL',
    code: 'SC688',
    category: 'Shipment',
    label: 'Solix Enroll',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'PRINT_LABEL_PORTIN_WITHOUT_MDN',
    code: 'SC689',
    category: 'Shipment',
    label: 'Eligible print label for portin dropshipment',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'DROPSHIP_PORTIN_SUCCESS_ACCOUNT_ACTIVE',
    code: 'SC166',
    category: 'Shipment',
    label: 'After Portin Success Dropship Account Activation',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'DROPSHIP_FAMILY_PLAN_NOT_CHECK_PARENT_ACCOUNT_ACTIVATION',
    code: 'SC125',
    category: 'Shipment',
    label: 'Dropship Family Plan Not Check Parent Account Activation First',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ALLOW_AUTOMATIC_ACTIVATION_BASIS_OF_SHIPMENT_NOTIFICATION',
    code: 'SC690',
    category: 'Shipment',
    label: 'Allow Automatic Activation Of Account Basis Of Shipment Notification',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'AUTOMATIC_ACTIVATION_BASIS_OF_SHIPMENT_NOTIFICATION_AFTER_GIVEN_MINUTES',
    code: 'SC691',
    category: 'Shipment',
    label: 'Automatic Activation Of Account Basis Of Shipment Notification After Given Minutes',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'NLAD_REVIEW',
    code: 'SC173',
    category: 'Review',
    label: 'Nlad Review Method',
    type: 'select',
    default: 'NO',
    options: ['NO', 'RESERVED_MDN_Form_NLAD', 'DUMMY_MDN_Form_Table'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'NLAD_FOR_TPIV',
    code: 'SC174',
    category: 'Review',
    label: 'Nlad For TPIV',
    type: 'select',
    default: 'NO',
    options: ['NO', 'RESERVED_MDN_Form_NLAD', 'DUMMY_MDN_Form_Table'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'IMAGE_ADVANCED_OPTIONS',
    code: 'SC175',
    category: 'Review',
    label: 'Review Image Advanced Options',
    type: 'boolean',
    default: false,
    options: ['YES', 'NO'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ENABLE_DELIVERY_OPTION_CONFIGURATION',
    code: 'SC176',
    category: 'Review',
    label: 'ENABLE DELIVERY OPTION CONFIGURATION',
    type: 'boolean',
    default: false,
    options: ['YES', 'NO'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'DEFAULT_DELIVERY_OPTION_WEBSITE',
    code: 'SC177',
    category: 'Review',
    label: 'Default Delivery Option For Website',
    type: 'select',
    default: '',
    options: ['', 'RETAILER_LOCATION', 'EVENT_TAKE_AWAY', 'SHIPMENT'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'DEFAULT_DELIVERY_OPTION_AGENT_PROGRAM',
    code: 'SC178',
    category: 'Review',
    label: 'Default Delivery Option For Agent Program',
    type: 'select',
    default: '',
    options: ['', 'RETAILER_LOCATION', 'EVENT_TAKE_AWAY', 'SHIPMENT'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'DEFAULT_DELIVERY_OPTION_TABLET',
    code: 'SC179',
    category: 'Review',
    label: 'Default Delivery Option For Tablet',
    type: 'select',
    default: '',
    options: ['', 'RETAILER_LOCATION', 'EVENT_TAKE_AWAY', 'SHIPMENT'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'DEFAULT_DELIVERY_OPTION_API',
    code: 'SC180',
    category: 'Review',
    label: 'Default Delivery Option For API',
    type: 'select',
    default: '',
    options: ['', 'RETAILER_LOCATION', 'EVENT_TAKE_AWAY', 'SHIPMENT'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'SHOW_DELIVERY_OPTION_WEBSITE',
    code: 'SC181',
    category: 'Review',
    label: 'Show Website Delivery Option to User',
    type: 'select',
    default: '',
    options: ['', 'YES', 'NO'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'SHOW_DELIVERY_OPTION_AGENT_PROGRAM',
    code: 'SC182',
    category: 'Review',
    label: 'Show Agent Program Delivery Option to User',
    type: 'select',
    default: '',
    options: ['', 'YES', 'NO'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'SHOW_DELIVERY_OPTION_TABLET',
    code: 'SC183',
    category: 'Review',
    label: 'Show Tablet Delivery Option to User',
    type: 'select',
    default: '',
    options: ['', 'YES', 'NO'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'SHOW_DELIVERY_OPTION_API',
    code: 'SC184',
    category: 'Review',
    label: 'Show API Delivery Option to User',
    type: 'select',
    default: '',
    options: ['', 'YES', 'NO'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'TAX_STATUS',
    code: 'SC185',
    category: 'Suretax Setting',
    label: 'Sure Tax Required?',
    type: 'boolean',
    default: false,
    options: ['YES', 'NO'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'SURETAX_LIVE',
    code: 'SC186',
    category: 'Suretax Setting',
    label: 'Suretax Producton Mode',
    type: 'boolean',
    default: false,
    options: ['YES', 'NO'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'TAX_STATUS_CREDITCARD',
    code: 'SC187',
    category: 'Suretax Setting',
    label: 'Tax required for Credit card Trans (Topup)',
    type: 'boolean',
    default: false,
    options: ['YES', 'NO'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'SURETAX_CASH',
    code: 'SC188',
    category: 'Suretax Setting',
    label: 'Tax required for Cash Trans (Topup)',
    type: 'boolean',
    default: false,
    options: ['YES', 'NO'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'SURETAX_WALLET_CUSTOMER',
    code: 'SC189',
    category: 'Suretax Setting',
    label: 'Tax required for Customer Wallet Trans (Topup)',
    type: 'boolean',
    default: false,
    options: ['YES', 'NO'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'SURETAX_WALLET_RETAILER',
    code: 'SC190',
    category: 'Suretax Setting',
    label: 'Tax required for Retailer Wallet Trans (Topup)',
    type: 'boolean',
    default: false,
    options: ['YES', 'NO'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'SURETAX_CUSTOMER_WALLET_PLAN_RENEW',
    code: 'SC191',
    category: 'Suretax Setting',
    label: 'Tax required for Customer Wallet (Plan Renew/Plan Change)',
    type: 'boolean',
    default: false,
    options: ['YES', 'NO'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'SURETAX_CASH_NEW_SIGNUP',
    code: 'SC581',
    category: 'Suretax Setting',
    label: 'Tax Charge New Signup in Cash',
    type: 'boolean',
    default: false,
    options: ['YES', 'NO'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'TAX_STATUS_CREDIT_CARD_SHIPPING_CHARGE',
    code: 'SC212',
    category: 'Suretax Setting',
    label: 'Tax required for Credit Card Trans (Shipping Charge)',
    type: 'boolean',
    default: false,
    options: ['YES', 'NO'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'TAX_STATUS_CREDIT_CARD_SIM_PURCHASE',
    code: 'SC840',
    category: 'Suretax Setting',
    label: 'Tax required for Credit Card Trans Trans (SIM purchase) .',
    type: 'boolean',
    default: false,
    options: ['YES', 'NO'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ACTIVATIONFEE_TAXCODE',
    code: 'SC204',
    category: 'Suretax Setting',
    label: 'Activation Fee Tax Code',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ACTIVATIONFEE_EXEMPTIONCODE',
    code: 'SC205',
    category: 'Suretax Setting',
    label: 'Activation Fee Exemption Code',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ALLOW_TAX_EXEMPTION',
    code: 'SC841',
    category: 'Suretax Setting',
    label: 'Allow Tax Exemption',
    type: 'boolean',
    default: false,
    options: ['YES', 'NO'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ILD_PROCESSING_FEE',
    code: 'SC217',
    category: 'ILD PROCESSING FEE',
    label: 'ILD processing fee required',
    type: 'boolean',
    default: false,
    options: ['YES', 'NO'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'DOLLARPHONE_LIVE',
    code: 'SC218',
    category: 'POS Setting',
    label: 'DollarPhone Producton Mode',
    type: 'boolean',
    default: false,
    options: ['YES', 'NO'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'USER_LEVEL_ACCESS_USERS',
    code: 'SC219',
    category: 'User Setting',
    label: 'Manage User Level Access Users',
    type: 'select',
    default: 'Active',
    options: ['Active', 'Inactive', 'Both'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ADD_UPDATE_SHIPPER_VENDOR',
    code: 'SC220',
    category: 'User Setting',
    label: 'add update shipper/vendor',
    type: 'boolean',
    default: false,
    options: ['YES', 'NO'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'MANAGE_USER_LEVEL_ACCESS_FILTERING',
    code: 'SC221',
    category: 'User Setting',
    label: 'Manage User Level Access Filter',
    type: 'boolean',
    default: false,
    options: ['YES', 'NO'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ALLOW_NLAD_RAD_ID_FOR_EMPLOYEE',
    code: 'SC222',
    category: 'User Setting',
    label: 'Allow NLAD RAD ID for Employee',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'AGENT_LABEL_NAME',
    code: 'SC223',
    category: 'User Setting',
    label: 'Agent Label Name',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'SIM_ESN_LABEL_NAME',
    code: 'SC224',
    category: 'User Setting',
    label: 'SIM/ESN Label Name',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'MAKE_MODEL_LABEL_NAME',
    code: 'SC225',
    category: 'User Setting',
    label: 'Make & Model Label Name',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ENABLE_ISP_CONFIG',
    code: 'SC226',
    category: 'User Setting',
    label: 'Enable ISP Config',
    type: 'boolean',
    default: false,
    options: ['Yes', 'No'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'DISPLAY_USER_PERMISSION_IN_NEW_TAB',
    code: 'SC229',
    category: 'User Setting',
    label: 'Display user permissions in new tab',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'BYPASS_PLAN_PERMISSION_FOR_SOURCE',
    code: 'SC230',
    category: 'User Setting',
    label: 'Bypass Plan Permission For Source',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'SEND_RESET_LINK_IN_ADD_EMPLOYEE',
    code: 'SC1362',
    category: 'User Setting',
    label: 'Send Reset Link In Add Employee',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ALLOW_LOCATION_SHARE_FOR_AGENT_LOGIN',
    code: 'SC1508',
    category: 'User Setting',
    label: 'Allow Location Share For Agent Login',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ALLOW_USER_TO_LOCK_AND_UNLOCK',
    code: 'SC515',
    category: 'User Setting',
    label: 'Allow User To Lock and Unlock',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ALLOW_DEGRADE_TO_PREVIOUS_PLAN',
    code: 'SC255',
    category: 'Plan Change/Renew Config',
    label: 'Allow Move To Previous Plan On Degrade Period',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'PLUMAPS',
    code: 'SC256',
    category: 'Plan Change/Renew Config',
    label: 'APS',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'HIDE_PRORATED_PLAN_FROM_PLAN_CONFIG',
    code: 'SC257',
    category: 'Plan Change/Renew Config',
    label: 'Hide Prorated Plan From Plan Config',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ALLOW_IOT_CHILD_LINE_PLAN_CHANGE_PLAN_RENEW_WITH_PARENT',
    code: 'SC258',
    category: 'Plan Change/Renew Config',
    label: 'Allow IOT Child Line Plan Change/Plan Renew With Parent',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'DECIMAL_DIGIT_NUMBER_USAGE',
    code: 'SC266',
    category: 'Plan Change/Renew Config',
    label: 'Number of decimal digits to show in Usage Billing.',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'DATA_USAGE_UNIT_TYPE',
    code: 'SC267',
    category: 'Plan Change/Renew Config',
    label: 'Data Usage Unit Type',
    type: 'select',
    default: 'GB',
    options: ['GB', 'MB', 'KB', 'Bytes'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'CARRIER_LIST_TO_SKIP_PLAN_PURCHASE',
    code: 'SC268',
    category: 'Plan Change/Renew Config',
    label: 'Carrier List To Skip Plan Purchase In Carrier( Comma separated)',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ALLOW_ONEXPIRY_PLAN_PURCHASE_FROM_AUTOPAY',
    code: 'SC692',
    category: 'Plan Change/Renew Config',
    label: 'Allow on expiry plan purchase payment from auto pay process',
    type: 'select',
    default: 'PLAN_CHANGE',
    options: ['PLAN_CHANGE'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'HIDE_TRIBAL_PLAN_FROM_TOPUP',
    code: 'SC273',
    category: 'Plan Change/Renew Config',
    label: 'Hide Tribal Plan (Applicable for tribal state) From Topup',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ALLOW_AUTOPAY_DISCOUNT_FOR_WALLET_PAYMENT',
    code: 'SC274',
    category: 'Plan Change/Renew Config',
    label: 'Allow Auto-pay Discount for Wallet Payment',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'PREVENT_AUTOPAY_DISCOUNT_FOR_PASSED_EXPIRY',
    code: 'SC275',
    category: 'Plan Change/Renew Config',
    label: 'Prevent Autopay Discount for Passed Expiry',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'DISPLAY_PLAN_TAX_IN_PLAN_CHANGE',
    code: 'SC276',
    category: 'Plan Change/Renew Config',
    label: 'Display Plan Tax in Plan Change/Renew',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ALLOW_PARTIAL_PAYMENT',
    code: 'SC282',
    category: 'Plan Change/Renew Config',
    label: 'Allow Partial Payment',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'PLAN_RENEW_USING_CREDIT_DISCOUNT',
    code: 'SC283',
    category: 'Plan Change/Renew Config',
    label: 'Plan Renew Using Credit Discount',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ALLLOW_PRE_ACTIVATION_APS_FOR_PLUM_CARRIER',
    code: 'SC285',
    category: 'Plan Change/Renew Config',
    label: 'Allow Pre Activation APS for plum carrier',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ALLOW_TOPUPTYPE_ILD_IN_LINKED_TOPUP',
    code: 'SC287',
    category: 'Plan Change/Renew Config',
    label: 'Allow Topup Type ILD in Linked Topup under ILD topups',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ALLOW_TAX_ON_TOTAL_PLAN_COST',
    code: 'SC281',
    category: 'Plan Change/Renew Config',
    label: 'Allow Tax On Total Plan Cost',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ALLOW_DISCOUNT_ON_ADVANCE_PURCHASE',
    code: 'SC1027',
    category: 'Plan Change/Renew Config',
    label: 'Allow discount on advace purchase',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ADD_ADVANCE_BILLING_MONTHS_ACTION',
    code: 'SC1012',
    category: 'Plan Change/Renew Config',
    label: 'Add Advance Billing Months Action',
    type: 'select',
    default: 'AMOUNT ADD TO WALLET',
    options: ['AMOUNT ADD TO WALLET', 'PLAN RENEW REQUEST'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ALLOW_TO_CREATE_DUPLICATE_PLAN_CODE',
    code: 'SC286',
    category: 'Plan Change/Renew Config',
    label: 'Allow To Create Duplicate Plan Code',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'LINE_PURCHASE_ALLOWED_TYPE',
    code: 'SC1278',
    category: 'Plan Change/Renew Config',
    label: 'Line purchase allowed type',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'LIFELINE_EBB_PLAN_ENABLE',
    code: 'SC585',
    category: 'Plan Change/Renew Config',
    label: 'Lifeline EBB Plan Enable',
    type: 'boolean',
    default: false,
    options: ['YES', 'NO'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ALLOW_UNLIMITED_ADVANCE_PLAN_PURCHASE',
    code: 'SC1046',
    category: 'Plan Change/Renew Config',
    label: 'Allow Unlimited advance plan purchase',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ADVANCE_PLAN_PURCHASE_PLAN_CHANGE_PLAN_RENEW',
    code: 'SC1044',
    category: 'Plan Change/Renew Config',
    label: 'Advance plan purchase and plan renew',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'RATE_GROUP_LIST_FOR_CA_STATE',
    code: 'SC590',
    category: 'Plan Change/Renew Config',
    label: 'Rate group list for ca state(Comma separated)',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ALLOW_CA_SERVICE_TYPE',
    code: 'SC475',
    category: 'Plan Change/Renew Config',
    label: 'CA Service Type Option(In Plan Config)',
    type: 'boolean',
    default: false,
    options: ['YES', 'NO'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'TRANSCODE_LIST',
    code: 'SC301',
    category: 'NETIP Config',
    label: 'Trans Code',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'RETAILPLAN_CONFIG',
    code: 'SC302',
    category: 'NETIP Config',
    label: 'Retail Plan',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'RENEW_PLAN_COMMISION_TYPE',
    code: 'SC304',
    category: 'Generate Commission',
    label: 'Renew Plan Commision Type',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'TPIV_FAIL_COMMISION_SETUP',
    code: 'SC305',
    category: 'Generate Commission',
    label: 'TPIV FAIL Intake Commission Setup',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'LIFE_LINE_COMMISION_SETUP',
    code: 'SC306',
    category: 'Generate Commission',
    label: 'LIFE LINE Commission Setup',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'PRE_PAID_COMMISION_SETUP',
    code: 'SC307',
    category: 'Generate Commission',
    label: 'PRE PAID Commission Setup',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'EQUIPMENT_COMMISION_SETUP',
    code: 'SC592',
    category: 'Generate Commission',
    label: 'Equipment Commission Setup',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ENROLLMENT_CATEGORY_SINGLE_OR_MUTLIPLE',
    code: 'SC594',
    category: 'Generate Commission',
    label: 'Is Single Enrollment Category Enabled(Commission Matrix)?',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'TOPUP_CATEGORY_WITHOUT_AMOUNT',
    code: 'SC595',
    category: 'Generate Commission',
    label: 'Is Toup Category Without Amount(Commission Matrix)?',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'MATRIX_COMMISSION_SOURCES',
    code: 'SC596',
    category: 'Generate Commission',
    label:
      'Matrix Commission Sources(Used For Topup/Datatopup, bill pay, plan purchase, equipment purchase upgrade device,Accessories Purchase )',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ENROLLMENT_COMMISSION_SOURCES',
    code: 'SC597',
    category: 'Generate Commission',
    label: 'Enrollment Commission Sources',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'PLAN_BASE_COMMISSION_MATRIX',
    code: 'SC1332',
    category: 'Generate Commission',
    label: 'Plan Base Commission matrix',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ALLOW_INACTIVE_CUSTOMERS_PREPAID_COMMISSION',
    code: 'SC1511',
    category: 'Generate Commission',
    label: 'Allow inactive customers for prepaid commission',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'VERIZON_USAGES_TYPE_GENERIC',
    code: 'SC310',
    category: 'Usages Settings According To Carrier For Activation',
    label: 'VERIZON USAGES TYPE',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'TALISPIRE_USAGES_TYPE_GENERIC',
    code: 'SC311',
    category: 'Usages Settings According To Carrier For Activation',
    label: 'TALISPIRE USAGES TYPE',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ITG_USAGES_TYPE_GENERIC',
    code: 'SC312',
    category: 'Usages Settings According To Carrier For Activation',
    label: 'ITG USAGES TYPE',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'SPRINT_USAGES_TYPE_GENERIC',
    code: 'SC313',
    category: 'Usages Settings According To Carrier For Activation',
    label: 'SPRINT USAGES TYPE',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'SPRINT_TAG_USAGES_TYPE_GENERIC',
    code: 'SC314',
    category: 'Usages Settings According To Carrier For Activation',
    label: 'SPRINT TAG USAGES TYPE',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'TMOBILE_USAGES_TYPE_GENERIC',
    code: 'SC315',
    category: 'Usages Settings According To Carrier For Activation',
    label: 'TMOBILE USAGES TYPE',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ATT_USAGES_TYPE_GENERIC',
    code: 'SC316',
    category: 'Usages Settings According To Carrier For Activation',
    label: 'ATT USAGES TYPE',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'TMOBILE_PWW_USAGES_TYPE_GENERIC',
    code: 'SC317',
    category: 'Usages Settings According To Carrier For Activation',
    label: 'TMOBILE PWW USAGES TYPE',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ADD_DENOMINATION_BY_PLAN',
    code: 'SC318',
    category: 'PIN Management',
    label: 'Add Denomination By Plan',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'SKIP_ADD_FAMILY_PLAN_CHILD_TO_OCS',
    code: 'SC328',
    category: 'Family Plan Config',
    label: 'Skip To Add Family Plan Child Lines To OCS',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ALLOW_PLAN_PURCHASE_FOR_ALL_CHILDREN_WITH_PARENT',
    code: 'SC330',
    category: 'Family Plan Config',
    label: 'Allow Purchase Plan For All Children If Plan Purchased For Parent',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'HIDE_CHANGE_PLAN_IN_UPGRADE_TO_FAMILY_PLAN',
    code: 'SC693',
    category: 'Family Plan Config',
    label: 'Hide Change Plan in Upgrade To Family Plan',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'DEFAULT_SAVE_CARD_DETAILS',
    code: 'SC331',
    category: 'Autopay and Payment',
    label: 'Default Save card details',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'CANCEL_AUTOPAY_NOT_ALLOWED_SOURCE',
    code: 'SC332',
    category: 'Autopay and Payment',
    label: 'Cancel Autopay not Allowed Source',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'REPLACE_CARD_AUTOPAY_WITH_PRIMERY_CARD',
    code: 'SC333',
    category: 'Autopay and Payment',
    label: 'Replace card autopay with primary card',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'LINE_WISE_AUTOPAY',
    code: 'SC343',
    category: 'Autopay and Payment',
    label: 'Line Wise Autopay Setup Minutes and Data',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'PAYMENT_USING_CARD_TOKEN',
    code: 'SC334',
    category: 'Autopay and Payment',
    label: 'Payment with card token in payment gateway',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'TOKEN_PAYMENT_GATEWAY_NAME',
    code: 'SC335',
    category: 'Autopay and Payment',
    label: 'Token Payment Gateway Name',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'REMOVE_ECHECK_SAVECARD_INACTIVE_CUSTOMER',
    code: 'SC347',
    category: 'Autopay and Payment',
    label: 'Remove Echeck and SaveCard inactive customer after Days',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'HOSTED_PAYMENT_CONFIG',
    code: 'SC1679',
    category: 'Autopay and Payment',
    label: 'Enable Hosted Payment',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'RESTRICTION_NOTIFICATION_CHILD_ACCOUNT',
    code: 'SC348',
    category: 'Notification Config',
    label: 'Restriction notification for child account',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'NOTIFICATION_MULTI_LANGUAGE',
    code: 'SC694',
    category: 'Notification Config',
    label: 'Is notification multi language',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'PLUM_PORTIN_REPLY_SMS',
    code: 'SC725',
    category: 'Notification Config',
    label: 'Plum Portin Reply SMS',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'HIGH_USAGE_EXCESSIVE_LIMIT',
    code: 'SC843',
    category: 'Notification Config',
    label: 'High Usage excessive limit (MB)',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'SEND_HIGH_USAGE_ALERT_EMAIL',
    code: 'SC844',
    category: 'Notification Config',
    label: 'Send High Usage alert Email (,) Separated',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'SEND_SMS_ON_ALTERNATE_NUMBER',
    code: 'SC350',
    category: 'Notification Config',
    label: 'Send SMS on Alternate Number',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ALLOW_PLAN_UPDATE_MANUALLY_IN_TEMPLATE',
    code: 'SC1512',
    category: 'Notification Config',
    label: 'Display Plan list in Notification Templates',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'BILL_PDF_MESSAGE_FOR_PLAN_HEADER',
    code: 'SC352',
    category: 'Billing Config',
    label: 'Bill PDF Message for plan header',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'BILL_PDF_MESSAGE_FOR_GLOBAL_UPDATE',
    code: 'SC353',
    category: 'Billing Config',
    label: 'Bill PDF Message for Global update',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'DEFAULT_CARRIER_FOR_PLAN_BUCKET',
    code: 'SC354',
    category: 'Billing Config',
    label: 'Default Carrier For Plan Bucket',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ENABLE_FRAUD_PREVENTION_FOR_PARENT_ALTERNATE_MOBILE_NO',
    code: 'SC358',
    category: 'Fraud Prevention',
    label: 'Enable Fraud Prevention for Parent alternate mobile no',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ENABLE_FRAUD_PREVENTION_FOR_PARENT_SERVICE_ADDRESS',
    code: 'SC695',
    category: 'Fraud Prevention',
    label: 'Enable Fraud Prevention for Parent Service Address',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'NUMBER_OF_ORDERS_ALLOWED_IN_PARENT_SERVICE_ADDRESS_FRAUD_PREVENTION',
    code: 'SC696',
    category: 'Fraud Prevention',
    label: 'Number of Orders Allowed in Parent Service Address Fraud Prevention',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'NUMBER_OF_DAYS_FOR_PARENT_SERVICE_ADDRESS_FRAUD_PREVENTION',
    code: 'SC697',
    category: 'Fraud Prevention',
    label: 'Number of Days For Parent Service Address Fraud Prevention',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ENABLE_FRAUD_PREVENTION_FOR_PARENT_EMAIL',
    code: 'SC364',
    category: 'Fraud Prevention',
    label: 'Enable Fraud Prevention for Parent Email',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ENABLE_FRAUD_PREVENTION_FOR_SIM_PURCHASE',
    code: 'SC365',
    category: 'Fraud Prevention',
    label: 'Enable Fraud Prevention for Sim Purchase',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'NUMBER_OF_ORDERS_ALLOW_FOR_SIM_PURCHASE',
    code: 'SC366',
    category: 'Fraud Prevention',
    label: 'Number of orders allow For Sim purchase',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'SAME_CREDIT_CARD_USED_LIMIT',
    code: 'SC367',
    category: 'Fraud Prevention',
    label: 'Same Credit Card used limit for different orders',
    type: 'select',
    default: '1',
    options: [
      '1',
      '2',
      '3',
      '4',
      '5',
      '6',
      '7',
      '8',
      '9',
      '10',
      '11',
      '12',
      '13',
      '14',
      '15',
      '16',
      '17',
      '18',
      '19',
      '20',
      '100',
    ],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ENABLE_FRAUD_PREVENTION_FOR_MINUTES_TOPUP',
    code: 'SC368',
    category: 'Fraud Prevention',
    label: 'Enable Fraud Prevention for ILD Topup',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'NUMBER_OF_ILD_TOPUP_ALLOWED_IN_BILLING_PERIOD',
    code: 'SC369',
    category: 'Fraud Prevention',
    label: 'Number of ILD Topup Allowed in Billing Period',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ENABLE_DISPATCH_TO_ACTIVE_AFTER_CREATE_CUSTOMER_PREPAID',
    code: 'SC372',
    category: 'REST API Config',
    label: 'Enable Dispatch To Active After Create Customer Prepaid',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'CHECK_BYOD_ESN_STATUS_FROM_CUSTOMER',
    code: 'SC373',
    category: 'REST API Config',
    label: 'Check BYOD ESN Status from Customer',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'CARD_AUTHORIZATION_CHARGE',
    code: 'SC698',
    category: 'REST API Config',
    label: 'Card Authorization Charge',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ENABLE_CUSTOMER_TEMPORARY_PASSWORD',
    code: 'SC699',
    category: 'REST API Config',
    label: 'Enable Customer Temporary Password',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'KEEP_CHILD_PASSWORD_SAME_AS_PARENT_ACCOUNT',
    code: 'SC377',
    category: 'REST API Config',
    label: 'Keep Child Password Same As Parent Account',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'DISABLE_CHANGE_PASSWORD_TO_CHILD_ACCOUNT',
    code: 'SC378',
    category: 'REST API Config',
    label: 'Disable Change Password To Child Account',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'KEEP_CHILD_IVR_PIN_SAME_AS_PARENT_ACCOUNT',
    code: 'SC700',
    category: 'REST API Config',
    label: 'Keep Child IVR Pin Same As Parent Account',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'DISABLE_CHANGE_IVR_PIN_TO_CHILD_ACCOUNT',
    code: 'SC383',
    category: 'REST API Config',
    label: 'Disable Change IVR Pin To Child Account',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ENABLE_CHILD_ACCOUNT_CREATION_IN_CASE_OF_ERROR',
    code: 'SC726',
    category: 'REST API Config',
    label: 'Enable Child Account Creation in Case of Error',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'AUTO_UNLOCK_CUSTOMER_ACCOUNT_IN_HOURS',
    code: 'SC379',
    category: 'REST API Config',
    label: 'Auto Unlock Customer Account in Hours',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ENABLE_ADDRESS_VALIDATE_FROM_USPS',
    code: 'SC376',
    category: 'REST API Config',
    label: 'Enable Address Validate From USPS',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ALLOW_ENROLLMENT_IN_CASE_OF_UNCONFIRMED_ADDRESS',
    code: 'SC375',
    category: 'REST API Config',
    label: 'Allow Enrollment in Case of Unconfirmed Address.',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ALLOW_LOGIN_TO_DISCONNECTED_CUSTOMER',
    code: 'SC381',
    category: 'REST API Config',
    label: 'Allow Login To Disconnected Customer',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'DISABLE_ADD_WALLET_FOR_CHILD',
    code: 'SC384',
    category: 'CSR Config',
    label: 'Disable Add Wallet For Child',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'CALCULATE_PLAN_TAX_IN_WALLET',
    code: 'SC385',
    category: 'CSR Config',
    label: 'Calculate Plan Tax while adding payment in wallet',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'SHOW_IVR_PIN_CUSTOMER_DASHBOARD',
    code: 'SC386',
    category: 'CSR Config',
    label: 'Show IVR PIN on Customer Dashboard',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ACTIVE_CHILD_ACCOUNT_EVEN_PARENT_IS_NOT_ACTIVE',
    code: 'SC387',
    category: 'CSR Config',
    label: 'Active Child Account even Parent is not Active',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'SHOW_TELEOPHONE_NUMBER_STATUS',
    code: 'SC388',
    category: 'CSR Config',
    label: 'Show Telephone Number Status',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'SHOW_LANGUAGE_DROPDOWN',
    code: 'SC701',
    category: 'CSR Config',
    label: 'Show Language Dropdown',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'CUSTOMER_ALLOWED_LANGUAGES',
    code: 'SC702',
    category: 'CSR Config',
    label: 'Customer Allowed Languages',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ENABLE_REFUND_STATUS_FOR_PREPAID_POSTPAID',
    code: 'SC389',
    category: 'CSR Config',
    label: 'Enable Refund Status for Prepaid Postpaid',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ENABLE_TAX_INCLUDED_COUPON',
    code: 'SC727',
    category: 'CSR Config',
    label: 'Enable Tax Included For Coupon',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'CHECK_DEVICE_WITH_WEBENROLL_INFO_FIRST',
    code: 'SC846',
    category: 'CSR Config',
    label: 'Check Device With Webenroll Info First',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'STORE_ZIPCODE_WHILE_CHANGING_ADDRESS',
    code: 'SC399',
    category: 'CSR Config',
    label: 'Store zipcode while changing address',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ENABLE_CHAT_ID_IN_NOTES',
    code: 'SC1411',
    category: 'CSR Config',
    label: 'Enable Chat Id In Notes',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ENABLE_CUSTOMER_EMAIL_VERIFICATION',
    code: 'SC1243',
    category: 'CSR Config',
    label: 'Enable Customer Email Verification',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'SHOW_ENROLLMENT_TYPE_FILTER',
    code: 'SC401',
    category: 'Report Config',
    label: 'Show Enrollment Type Filter in Activation Report',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'SHOW_LIFELINE_ENROLLMENT_TYPE',
    code: 'SC402',
    category: 'Report Config',
    label: 'Show Lifeline Enrollment Type',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'SHOW_MASTER_AGENT_FILTER',
    code: 'SC703',
    category: 'Report Config',
    label: 'Show Master Agent Filter',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'DISPLAY_OLD_CARRIER_IN_PENDING_PORT',
    code: 'SC847',
    category: 'Report Config',
    label: 'Display Old Carrier in Pendig Port List',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'SHOW_PRODUCT_TYPE_FOR_NON_LIFELINE',
    code: 'SC670',
    category: 'Report Config',
    label: 'Show Product Type For Non Lifeline PC61',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ENABLE_IVR_OUTAGE',
    code: 'SC714',
    category: 'Outage',
    label: 'Enable IVR Outage',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ENABLE_WEBSITE_OUTAGE',
    code: 'SC715',
    category: 'Outage',
    label: 'Enable Website Outage',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'IVR_OUTAGE_MESSAGE',
    code: 'SC716',
    category: 'Outage',
    label: 'IVR Outage Message (Special characters not allowed)',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'WEBSITE_HEADER_OUTAGE_MESSAGE_ENGLISH',
    code: 'SC717',
    category: 'Outage',
    label: 'Website Header Outage Message English',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'WEBSITE_HEADER_OUTAGE_MESSAGE_SPANISH',
    code: 'SC718',
    category: 'Outage',
    label: 'Website Header Outage Message Spanish',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'WEBSITE_MAINTENANCE_HEADING_ENGLISH',
    code: 'SC719',
    category: 'Outage',
    label: 'Website Maintenance Heading English',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'WEBSITE_MAINTENANCE_HEADING_SPANISH',
    code: 'SC720',
    category: 'Outage',
    label: 'Website Maintenance Heading Spanish',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'WEBSITE_MAINTENANCE_BODY_ENGLISH',
    code: 'SC721',
    category: 'Outage',
    label: 'Website Maintenance Body English',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'WEBSITE_MAINTENANCE_BODY_SPANISH',
    code: 'SC722',
    category: 'Outage',
    label: 'Website Maintenance Body Spanish',
    type: 'text',
    default: '',
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'PUSH_NOTIFICATION_TYPE_ENABLE',
    code: 'SC416',
    category: 'Manage System Config',
    label: 'Push Notification Type Enable',
    type: 'boolean',
    default: false,
    options: ['Y', 'N'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'PORT_OUT_ACTION_BLUECONNECTSATT_PORTOUT',
    code: 'SC1418',
    category: 'Port-out Config Blueconnectsatt',
    label: 'Blueconnectsatt Port out action',
    type: 'select',
    default: 'MANUAL',
    options: ['MANUAL', 'AUTO APPROVE'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'ACCOUNT_NO_VALIDATION_BLUECONNECTSATT_PORTOUT',
    code: 'SC1419',
    category: 'Port-out Config Blueconnectsatt',
    label: 'Blueconnectsatt- Account No validation is required ?',
    type: 'boolean',
    default: false,
    options: ['YES', 'NO'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
  {
    key: 'MSISDN_VALIDATE_BLUECONNECTSATT_PORTOUT',
    code: 'SC1421',
    category: 'Port-out Config Blueconnectsatt',
    label: 'Blueconnectsatt- MSISDN validation is required ?',
    type: 'boolean',
    default: false,
    options: ['YES', 'NO'],
    help: '',
    inert: true,
    feature: 'system-config-all',
  },
] as const satisfies readonly SettingDef[];
